var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 16C2.448 16 2 15.6326 2 15.1818V7H18V15.1818C18 15.6326 17.552 16 17 16H3ZM5 3C5 3.552 5.447 4 6 4C6.553 4 7 3.552 7 3H13C13 3.552 13.447 4 14 4C14.553 4 15 3.552 15 3H17C17.552 3 18 3.449 18 4V5H2V4C2 3.449 2.448 3 3 3H5ZM15 1C15 0.448 14.553 0 14 0C13.447 0 13 0.448 13 1H7C7 0.448 6.553 0 6 0C5.447 0 5 0.448 5 1H3C1.346 1 0 2.346 0 4V15C0 16.654 1.346 18 3 18H17C18.654 18 20 16.654 20 15V4C20 2.346 18.654 1 17 1H15Z",
    fill: "#EF3340"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarRed);
export default __webpack_public_path__ + "static/media/calendar-red.ffa5fb9ed8bd25de4327b4a709e526f1.svg";
export { ForwardRef as ReactComponent };